import { sendBroadCast } from "../../Pages/utils/global";
import {
  getRequest,
  otpPostRequest,
  postRequest,
  postRequestOtp,
} from "../../services/axios";
import {
  USER_INFO_REQUEST,
  USER_INFO_FAIL,
  USER_INFO_SUCCESS,
  USER_LOGOUT,
  USER_SUBSCRIBE_REQUEST,
  USER_SUBSCRIBE_SUCCESS,
  USER_SUBSCRIBE_FAIL,
  USER_OTP_REQUEST,
  USER_OTP_SUCCESS,
  USER_OTP_FAIL,
  UPDATE_USER_RENDER_CNT,
  UPDATE_USER_RENDER_CNT_FAIL,
  INCREASE_RENDER_CNT,
} from "./types";

export const login = (email, password, navigate) => async (dispatch) => {
  try {
    dispatch({ type: USER_INFO_REQUEST });
    const response = await postRequest("/user/login", { email, password });
    const { data } = response;
    if (response?.status === 200 && data?.success) {
      if (data?.authToken && data?.authToken.length > 0) {
        localStorage.setItem("authToken", JSON.stringify(data?.authToken));
      }
      localStorage.setItem("user", JSON.stringify(data?.user));
      dispatch({
        type: USER_INFO_SUCCESS,
        payload: { userInfo: data?.user, authToken: data?.authToken },
      });
      sendBroadCast("logInChannel", "logIn");
      return data;
    } else {
      return response;
    }
  } catch (error) {
    dispatch({
      type: USER_INFO_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
    return error;
  }
};
// login with google
export const loginWithGoogle = (body) => async (dispatch) => {
  try {
    dispatch({ type: USER_INFO_REQUEST });
    const response = await postRequest("/user/googleLogin", body);
    const { data } = response;
    if (response?.status === 200 && data?.success) {
      if (data?.authToken && data?.authToken.length > 0) {
        localStorage.setItem("authToken", JSON.stringify(data?.authToken));
      }
      localStorage.setItem("user", JSON.stringify(data?.user));
      dispatch({
        type: USER_INFO_SUCCESS,
        payload: { userInfo: data?.user, authToken: data?.authToken },
      });
      sendBroadCast("logInChannel", "logIn");
      return data;
    } else {
      return response;
    }
  } catch (error) {
    dispatch({
      type: USER_INFO_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
    return error;
  }
};
export const register =
  (
    { email, firstName, lastName, phoneNo, company, password, confirmPassword },
    navigate
  ) =>
  async (dispatch) => {
    try {
      dispatch({ type: USER_INFO_REQUEST });
      const response = await postRequest("/user", {
        email,
        firstName,
        lastName,
        phoneNo,
        company,
        password,
        confirmPassword,
      });

      if (response?.data) {
        localStorage.setItem(
          "dup-authToken",
          JSON.stringify(response?.data?.authToken)
        );
        localStorage.setItem("dup-user", JSON.stringify(response?.data?.user));
        dispatch({
          type: USER_INFO_SUCCESS,
          payload: {
            userInfo: response?.data?.user,
            authToken: response?.data?.authToken,
          },
        });
      } else {
        console.log("register faild", response);
      }
      return response;
    } catch (error) {
      dispatch({
        type: USER_INFO_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
      return error;
    }
  };

export const logout = (navigate) => (dispatch) => {
  dispatch({ type: USER_LOGOUT });
  navigate();
  sendBroadCast("logoutChannel", "logout");
};

export const emailSubscriber = (apiDataForSend) => async (dispatch) => {
  try {
    dispatch({ type: USER_SUBSCRIBE_REQUEST });
    const data = await postRequest("/consumers", apiDataForSend);
    dispatch({
      type: USER_SUBSCRIBE_SUCCESS,
      payload: { userCaptcha: data },
    });
    return data;
  } catch (error) {
    dispatch({
      type: USER_SUBSCRIBE_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

// verify OTP
export const verifyOTP = (email, otp, otpType, password) => async (dispatch) => {
  try {
    dispatch({ type: USER_OTP_REQUEST });
    const response = await otpPostRequest("/otp/verifyOtp", {
      email,
      otp,
      otpType,
      password,
    });
    const user = localStorage.getItem("dup-user");
    const authToken = localStorage.getItem("dup-authToken");
    localStorage.setItem("user", user);
    localStorage.setItem("authToken", authToken);

    return response;
    // localStorage.setItem("authToken", JSON.stringify(data.authToken));

    // dispatch({
    //   type: USER_OTP_SUCCESS,
    //   payload: { userOTP: data.user, authToken: data.authToken },
    // });
  } catch (error) {
    dispatch({
      type: USER_OTP_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};
// /api/otp/resendOtp
export const resndOTP = () => async (dispatch) => {
  console.log(" API Call handleResendOtp resndOTP");
  try {
    dispatch({ type: USER_OTP_REQUEST });
    const response = await postRequest("/otp/resendOtp");
    console.log("resendOtp res ", response);
    return response;
  } catch (error) {
    return error;
  }
};

// forgot password
export const forgotPassword = (email) => async (dispatch) => {
  try {
    dispatch({ type: USER_INFO_REQUEST });
    const response = await postRequest("/user/resetPassword", { email });
    // console.log(" API Response to Generate OTP for forgotPassword ", response);
    const { data } = response;
    // console.log("User data => ", data);

    const { authToken, ...dataWithoutToken } = data || {};
    // console.log("dataWithoutToken = ",dataWithoutToken);

    if (response?.status === 200 && data?.success) {
      // Not set without Verify OTP
      // if (data?.authToken && data?.authToken.length > 0) {
      //   localStorage.setItem("authToken", JSON.stringify(data.authToken));
      // }

      dispatch({
        type: USER_INFO_SUCCESS,
        payload: { userInfo: data.user, authToken: data.authToken },
      });

      return dataWithoutToken;
    } else {
      return response;
    }
  } catch (error) {
    dispatch({
      type: USER_INFO_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
    return error;
  }
};

// user Password Reset
export const passwordReset =
  (currentPassword, newPassword, confirmPassword) => async (dispatch) => {
    try {
      const response = await postRequest("/user/userResetPassword", {
        currentPassword,
        newPassword,
        confirmPassword,
      });
      return response;
    } catch (error) {
      return error;
    }
  };

export const getRenderCnt = () => async (dispatch) => {
  try {
    const response = await getRequest("/user/getRenderCnt");

    if (response.data?.success) {
      dispatch({
        type: UPDATE_USER_RENDER_CNT,
        payload: response.data.renderCnt,
      });
    } else {
      dispatch({
        type: UPDATE_USER_RENDER_CNT_FAIL,
        payload: { error: "Failed to retrieve render count" },
      });
    }
  } catch (error) {
    dispatch({
      type: UPDATE_USER_RENDER_CNT_FAIL,
      payload: {
        error:
          error.response?.data?.message ||
          error.message ||
          "Something went wrong",
      },
    });
  }
};

export const increaseRenderCnt = () => (dispatch) => {
  dispatch({
    type: INCREASE_RENDER_CNT,
  });
};
